import t from "./index967.js";
function e(a) {
  return t(this, a).has(a);
}
export {
  e as default
};
